import React, {Component} from 'react';
import {connect} from "react-redux";
import EditingSettings from "../../components/EditingSettings/editingSettings";
import {requestGetQuestions} from "../../actions/applicationFormreferralSettings";
import {
    changeEditingSettings,
    fetchEditingSettings,
    fetchEditingSettingsEditableByOptions,
    updateEditingSettings
} from "../../actions/editingSettings";
import {APPLICATION_FORM_FIELDS} from "../../helpers/variables";
import _ from "lodash";
import editingSettings from "../../reducers/editingSettings";

class EditingSettingsHOC extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getQuestions();
        this.props.fetchEditingSettingsEditableByOptions();
        this.props.fetchEditingSettings();
    }

    getEditingSettingsOptions = () => {
        return this.props.approvalOptions.map(i => ({
            key: i.id,
            value: i.name
        }));
    };

    getQuestionFromEditingSetting = (editingSetting) => {
        if(!editingSetting){
            return {};
        }

        const found = this.props.questions.find(a => a.id.toString() === editingSetting.questionId.toString());
        if(found){
            return found;
        }

        return {};
    };

    getFieldFormEditingSetting = (editingSetting) => {
        if(!editingSetting){
            return {};
        }

        const found =_.find(APPLICATION_FORM_FIELDS, field => field.fieldName === editingSetting.columnName);
        if(found){
            return {
                id: null,
                isParent: true,
                name: found.name
            };
        }

        return {};
    };

    getEditingSettingFromQuestionId = (questionId) => {
        const found = this.props.editingSettings.find(e => (
            e.questionId
            && questionId
            && e.questionId.toString() === questionId.toString())
        );
        if(found){
            return found;
        }

        return {};
    };

    getEditingSettingFromTableName = (tableName) => {
        const found = this.props.editingSettings.find(e => (
            e.tableName
            && tableName
            && e.tableName.toString() === tableName.toString())
        );
        if(found){
            return found;
        }

        return {};
    };

    handleSaveChanges  = () => {
        const sendBody = this.props.editingSettings
            .filter(setting => (
                this.props.editingSettingsValues[setting.id]
                && setting.applicationAnswerApprovalOptionId
                && setting.applicationAnswerApprovalOptionId.toString() !== this.props.editingSettingsValues[setting.id].toString()
            ))
            .map(setting => ({
                ...setting,
                applicationAnswerApprovalOptionId: this.props.editingSettingsValues[setting.id]
            }));

        this.props.updateEditingSettings({sendBody});
    };

    render() {
        return (
            <EditingSettings
                {...this.props}
                getEditingSettingFromTableName={this.getEditingSettingFromTableName}
                editingSettingsOptions={this.getEditingSettingsOptions()}
                getQuestionFromEditingSetting={this.getQuestionFromEditingSetting}
                getFieldFormEditingSetting={this.getFieldFormEditingSetting}
                getEditingSettingFromQuestionId={this.getEditingSettingFromQuestionId}
                handleSaveChanges={this.handleSaveChanges}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        questions: state.applicationFormReferralSettings.questions,
        fetchingQuestions: state.applicationFormReferralSettings.fetching,
        editingSettings: state.editingSettings.approvalSettings,
        editingSettingsValues: state.editingSettings.values,
        updating: state.editingSettings.updating,
        approvalOptions: state.editingSettings.approvalOptions,
        fetchingEditingSettings: state.editingSettings.fetchingEditingSettings,
        fetchingEditingSettingsEditableByOptions: state.editingSettings.fetchingEditingSettingsEditableByOptions,
        updateErrorMessage: state.editingSettings.updateErrorMessage,
        updateSuccessMessage: state.editingSettings.updateSuccessMessage
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getQuestions: () => {
            dispatch(requestGetQuestions())
        },
        changeEditingSettings: (payload) => {
            dispatch(changeEditingSettings(payload))
        },
        updateEditingSettings: (payload) => {
            dispatch(updateEditingSettings(payload))
        },
        fetchEditingSettings: (payload) => {
            dispatch(fetchEditingSettings(payload))
        },
        fetchEditingSettingsEditableByOptions: (payload) => {
            dispatch(fetchEditingSettingsEditableByOptions(payload))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(EditingSettingsHOC);